import React, { Component } from 'react';
import { I18n, translate } from 'react-i18next';
import { parse } from 'qs';
import RegionDropdown from './regionDropdown';

class Header extends Component {
  constructor(props) {
    super(props);
    this.query = parse(window.location.search.replace('?', ''));
    this.hideLogo = this.query.logo === 'false' || false;
    this.hideHeader = this.query.iframe === 'true' || false;
  }

  render() {
    if (this.hideHeader) {
      return null;
    }

    return (
      <I18n ns="translations">
        {() => (
          <section className="header">
            <div className="container">
              <div className="header__logo-holder">
                {!this.hideLogo && <img className="logo" src="images/logo.png" alt="logo" />}
              </div>
              <RegionDropdown />
            </div>
          </section>
        )}
      </I18n>
    );
  }
}

export default translate('translations')(Header);
